import React, { useEffect } from "react";
import { Provider } from "react-redux";
import store from "./redux/store";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./themes/themes";
import { v4 as uuidv4 } from "uuid";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./ReactQuery/reactQueryClient";
import AuthWall from "./AuthWall";
import FpToast from "./components/common/FpToast";
import ToolTip2 from "./components/common/ToolTip2";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./ErrorFallback";

function App() {
  useEffect(() => {
    console.log(`
███████╗██╗███╗   ██╗██████╗ ██╗██╗      ██████╗ ████████╗
██╔════╝██║████╗  ██║██╔══██╗██║██║     ██╔═══██╗╚══██╔══╝
█████╗  ██║██╔██╗ ██║██████╔╝██║██║     ██║   ██║   ██║   
██╔══╝  ██║██║╚██╗██║██╔═══╝ ██║██║     ██║   ██║   ██║   
██║     ██║██║ ╚████║██║     ██║███████╗╚██████╔╝   ██║   
╚═╝     ╚═╝╚═╝  ╚═══╝╚═╝     ╚═╝╚══════╝ ╚═════╝    ╚═╝
      `);
    sessionStorage.setItem("sessionId", uuidv4());
  }, []);

  // The desktop-only gate is gone (#11742): small screens are supported —
  // the shell adapts (drawer nav, overlay viewers, the gutter ladder)
  // instead of turning phones away.
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <FpToast />
      <ToolTip2 />
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <QueryClientProvider client={queryClient}>
              <AuthWall />
            </QueryClientProvider>
          </LocalizationProvider>
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
